import axios from 'axios'
import { camelizeKeys, decamelizeKeys } from 'humps'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  withCredentials: true,
})

apiClient.interceptors.response.use(
  (response) => {
    if (!(response.data instanceof Blob)) {
      response.data = camelizeKeys(response.data)
    }
    return response
  },
  error => Promise.reject(error),
)

apiClient.interceptors.request.use(
  (config) => {
    if (config.data && !(config.data instanceof FormData)) {
      config.data = decamelizeKeys(config.data)
    }
    return config
  },
  error => Promise.reject(error),
)

export default apiClient
